import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  BusinessPerson,
  BusinessPersonEvent,
  StaffGroupBusinessPerson
} from '@sd-portal/shared/models';

@Injectable()
export class BusinessPersonService {
  constructor(private readonly http: HttpClient) {}

  searchBusinessPersonDtos(searchString: string) {
    const url = '/sdapi/pre-flight/Scheduling/BusinessPersons';
    return this.http.get<BusinessPerson[]>(url, {
      params: new HttpParams().set('searchText', searchString)
    });
  }

  searchStaffBusinessPersonDtos(searchString: string) {
    const url = '/sdapi/pre-flight/Scheduling/BusinessPersons/Staff';
    return this.http.get<BusinessPerson[]>(url, {
      params: new HttpParams().set('searchText', searchString)
    });
  }

  searchStaffGroupBusinessPersonDtos(searchString: string) {
    const url = '/sdapi/pre-flight/Scheduling/BusinessPersons/StaffGroup';
    return this.http.get<StaffGroupBusinessPerson[]>(url, {
      params: new HttpParams().set('searchText', searchString)
    });
  }

  getStaffBusinessPersonEvents(startDate: string, endDate: string) {
    const url = '/sdapi/pre-flight/Scheduling/BusinessPersons/GetStaffEventsConflicts';
    return this.http.post<BusinessPersonEvent[]>(url, {
      startDateTime: startDate,
      endDateTime: endDate
    });
  }
}
